/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ukca': {
    width: 16,
    height: 16,
    viewBox: '0 0 64 64',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M1.6 1.6v18.708c0 4.677 3.827 8.928 8.929 8.928h10.204c4.677 0 8.929-3.826 8.929-8.928V1.6h-6.803v18.708c0 1.275-1.276 2.55-2.551 2.55h-9.78c-1.275 0-2.55-1.275-2.55-2.55V1.6H1.6zM34.339 1.6v27.636h6.377V19.032l12.33 10.204h8.929L44.118 15.631 61.975 1.6h-8.929l-12.33 10.203V1.6H34.34zM29.236 34.338v6.378H10.53c-1.276 0-2.551 1.276-2.551 2.551v10.204c0 1.276 1.275 2.551 2.55 2.551h18.709V62.4H10.529C5.852 62.4 1.6 58.573 1.6 53.47V43.267c0-4.677 3.827-8.929 8.929-8.929h18.707zM40.716 49.22h14.881v-6.378c0-1.276-1.275-2.551-2.55-2.551H42.841c-1.275 0-2.55 1.275-2.55 2.55v6.378h.424zM34.34 61.974V43.267c0-4.677 3.826-8.929 8.928-8.929h10.204c4.677 0 8.93 3.827 8.93 8.93v18.707h-6.379v-6.378H40.717v6.378H34.34z" _fill="#1F222C"/>'
  }
})
